export const expertBioApiConstants = {
  histogram: {
    histogram: [],
    startYear: "",
    recentYear: "",
    totalArticles: 0,
    isFetching: false
  },
  collabs: {
    collabs: [],
    totalCollabs: 0,
    isFetching: false
  },
  credentials: {
    credentials: {},
    expertsFullInfo: {},
    intrests: [],
    keywordRanks: {},
    isFetching: false
  },
  articles: {
    articles: [],
    totalArticles: 0,
    from: 0,
    activePage: 1,
    size: 10,
    sort: "citation",
    isFetching: false
  },
  msArticles: {
    msaArticlesList: [],
    total: 0,
    from: 0,
    size: 10,
    activePage: 1,
    isFetching: false
  },
  trials: {
    trials: [],
    totalTrials: 0,
    from: 0,
    size: 10,
    activePage: 1,
    isFetching: false
  },
  grants: {
    grants: [],
    totalGrants: 0,
    from: 0,
    size: 10,
    activePage: 1,
    isFetching: false
  },
  payments: {
    payments: [],
    totalOpenPayment: 0,
    from: 0,
    size: 10,
    activePage: 1,
    isFetching: false
  },
  patents: {
    patents: [],
    totalPatents: 0,
    from: 0,
    size: 10,
    activePage: 1,
    isFetching: false,
  },
  externalLinks: {
    bioLinks: [],
    conferenceLinks: [],
    corporateLinks: [],
    isAdmin: false,
    isFetching: false
  }
};
